import React from "react"

export const SixMonsLeaveColumn = () => [
  {
    Header: "Month",
    accessor: "month",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Leaves",
    accessor: "leaves",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
]
